import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MenuNavigationService } from '../services';
import { UserProvider } from '../services/user.provider';

/**
 * redirects to the 404 page.
 * @returns {boolean} always false, so callers can `return redirectToUnauthorized(router)`.
 */
function redirectToUnauthorized(router: Router): boolean {
  router.navigate(['/404-page'], {
    replaceUrl: true,
  });
  return false;
}

/**
 * blocks access when the user has no admin struttura, or lacks the route's required admin permission.
 * @returns {boolean} true if the route can be activated, false otherwise.
 */
export const adminPermissionGuard: CanActivateFn = (route) => {
  const userProvider = inject(UserProvider);
  const router = inject(Router);
  const menuService = inject(MenuNavigationService);
  const userInfo = userProvider.userInfo;

  if (userInfo?.strutturaAdmin) {
    userProvider.setPermissionList(userInfo.strutturaAdmin.permessiVisivi);
    userProvider.setSelectedStruttura(userInfo.strutturaAdmin);
    menuService.setSelectedApp('amministrazione');
  }
  const isSuperAdmin = userProvider.isSuperAdmin;
  if (isSuperAdmin) return true;

  const requiredPermission = route.data['permission'] as string;

  if (!requiredPermission) {
    return userInfo?.strutturaAdmin ? true : redirectToUnauthorized(router);
  }

  const hasPermission = userProvider.hasAdminPermission(requiredPermission);
  if (hasPermission) return true;

  return redirectToUnauthorized(router);
};
